import { SYMBOL_ONLY, SYMBOL_VIEWBOX } from '@/components/brand/Logo'
import { AgentSidePanel } from '../AgentChat/AgentSidePanel'
import { useAskCaiPanel } from './AskCaiProvider'
import { useCustomerPageContext } from './pageContext'

/**
 * Ask Cai as a right-hand panel, available on every customer page. The same
 * component the staff drawer uses, pointed at the customer endpoints by the
 * provider — the thread dropdown, tool cards and page-context chip all follow.
 */
export function AskCaiDrawer() {
  const panel = useAskCaiPanel()
  const pageContext = useCustomerPageContext()

  return (
    <AgentSidePanel
      panel={panel}
      pageContext={pageContext}
      title="Ask Cai"
      icon={
        <svg
          className="text-brand-700 size-5 shrink-0"
          viewBox={SYMBOL_VIEWBOX}
          aria-hidden
          xmlns="http://www.w3.org/2000/svg"
        >
          {SYMBOL_ONLY.map((d) => (
            <path key={d} d={d} fill="currentColor" />
          ))}
        </svg>
      }
      emptyStateDescription="Ask about your policy, fleet, claims or documents — Cai can see the page you’re on."
    />
  )
}
